var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.12 5v6.708h6.708A6.708 6.708 0 0013.12 5zm-1.235 1.06a6.884 6.884 0 106.885 6.884h-6.886V6.058l.001.001z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
export default SvgKeyResult;